import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import { bankModelGet, } from '../../models/banks/bank';
import { responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, buttonProcessGet, languageObjGet, awaitDelay, isUndNullEmp, } from '../../helpers/settings'
import axios from 'axios';
import { coinModelGet } from '../../models/coins/coin';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'BanksAddEditDetails';

const { app, collections: dbColle, icons, images, labels, messages, react } = globalSettings;
const { backend, } = app;
const { html: reactHtml, } = react;
const { properties: dbProps, } = dbColle;

export default function BanksAddEditDetails({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    bank = bankModelGet({}),
    setBank = () => { },
    countries = [coinModelGet({})],
    dtBanksId = '',
    dtBanksRowIndex = 0,
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [rifError, setRifError] = useState('');
    const [codeError, setCodeError] = useState('');
    const [countryIdError, setCountryIdError] = useState('')
    const [descriptionError, setDescriptionError] = useState('');
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnBankModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnBankModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnBankModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // inactive: {
            //     id: 'chkBankModalEnable',
            //     className: 'icheck-primary d-inline',
            // },
            // inactiveReadOnly: {
            //     id: 'chkBankModalReadOnly',
            //     className: 'icheck-primary d-inline',
            // },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCountryesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCountryesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCountryesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCountryesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCountryesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCountryesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCountryesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCountryesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoBankModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoBankModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoBankModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            description: {
                id: 'inputBankModalDescription',
                className: 'form-control',
            },
            code: {
                id: 'inputBankModalCode',
                className: 'form-control',
            },
            rif: {
                id: 'inputBankModalRif',
                className: 'form-control',
            },
        },
        selects: {
            countries: {
                id: 'selBankModalCountries',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spBankModalSave',
                className: '',
            },
            back: {
                id: 'spBankModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region bank (methods)
    const bankAddPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'bankAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                bank: bank,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBanks}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            bank = response?.result || {};
            $(`#${dtBanksId}`)?.DataTable()?.row?.add([
                bank?.description,
                bank?.code,
                bank?.rif,
                buttonProcessGet({
                    id: bank?.id,
                    description: bank?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion data save

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const bankEditPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'bankEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                bank: bank,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBanks}/${bank?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            bank = response.result;
            $(`#${dtBanksId}`)?.DataTable()?.row(dtBanksRowIndex)?.data?.([
                bank?.description,
                bank?.code,
                bank?.rif,
                buttonProcessGet({
                    id: bank?.id,
                    description: bank?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion data save

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion bank (methods)

    //#region methods
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSet = ({
        property = '',
        value = '',
        subMethod = '',
    }) => {
        const currentMethod = 'formDataSet';
        let response = responseGet();
        try {
            setBank({
                ...bank,
                [property]: value,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
    }

    const validateFormData = ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormData';
        let response = responseGet();
        try {
            //#region methods
            if (isUndNullEmp({ data: bank?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: bank?.code, subMethod: currentMethod, })?.result) {
                setCodeError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (bank?.code?.length !== 4) {
                setCodeError(`${messages?.thisFieldRequired?.[languageObj?.id]}. 4 ${labels?.characters?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: bank?.rif, subMethod: currentMethod, })?.result) {
                setRifError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (bank?.rif?.length !== 10) {
                setRifError(`${messages?.thisFieldRequired?.[languageObj?.id]}. 10 ${labels?.characters?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: bank?.countryId, subMethod: currentMethod, })?.result) {
                setCountryIdError(`${messages?.youMustSelectCountry?.[languageObj?.id]}`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const errorsDefaultSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'errorsDefaultSet';
        let response = responseGet();
        try {
            setRifError('');
            setCodeError('');
            setCountryIdError('');
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const controlsStatusSet = ({
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.description?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.code?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.inputs?.rif?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.selects?.countries?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
    }, [auth]);
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt='banks'
                        src={images?.banksLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.bank?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ?
                bankAddPostAsync({ e: e, subMethod: 'form - onSubmit', }) :
                bankEditPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processType === 0 ? bankAddPostAsync(e) : bankEditPostAsync(e)}> */}

                    {/* <div className='card-header'>
                            <h6 className='card-title'><img alt='banks' src={images?.banksLogo} style={styles?.cardHeaderLogo}></img> - {labels?.bank?.[languageObj?.id]}</h6>
                        </div> */}

                    {/* <div className='card-body'> */}
                    {processType !== 2 ?
                        <div>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.description?.id}
                                        className={controls?.inputs?.description?.className}
                                        placeholder={labels?.name?.[languageObj?.id]}
                                        tabIndex={0}
                                        onChange={(e) => formDataSet({
                                            property: dbProps?.description,
                                            value: e?.target?.value,
                                            subMethod: 'input - description',
                                        })}
                                        onFocus={() => setDescriptionError('')}
                                        value={bank?.description || ''}
                                        tooltip='tooltip'
                                        title={labels?.name?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.spellCheck} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.code?.id}
                                                className={controls?.inputs?.code?.className}
                                                placeholder={labels?.code?.[languageObj?.id]}
                                                onChange={(e) => formDataSet({
                                                    property: dbProps?.code,
                                                    value: e?.target?.value,
                                                    subMethod: 'input - code',
                                                })}
                                                onFocus={() => setCodeError('')}
                                                value={bank?.code || ''}
                                                tooltip='tooltip'
                                                title={labels?.code?.[languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(codeError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.rif?.id}
                                                className={controls?.inputs?.rif?.className}
                                                placeholder={labels?.rif?.[languageObj?.id]}
                                                onChange={(e) => formDataSet({
                                                    property: dbProps?.rif,
                                                    value: e?.target?.value,
                                                    subMethod: 'inpyt - rif',
                                                })}
                                                onFocus={() => setRifError('')}
                                                value={bank?.rif || ''}
                                                tooltip='tooltip'
                                                title={labels?.rif?.[languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(rifError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <select id={controls?.selects?.countries?.id}
                                        className={controls?.selects?.countries?.className}
                                        defaultValue={bank?.countryId || ''}
                                        onChange={(e) => formDataSet({
                                            property: dbProps?.countryId,
                                            value: e?.target?.value,
                                            subMethod: 'selects - countries',
                                        })}
                                        onFocus={() => setCountryIdError('')}>
                                        <option key='nothing' value=''>{labels?.selectCountry?.[languageObj?.id]}</option>
                                        {countries?.map((country) => <option key={country?.id} value={country?.id}>{country?.description}</option>)};
                                    </select>
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className='fas fa-globe-americas' />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(countryIdError)}</div>
                            </div>
                        </div>
                        :
                        <div className='text-muted'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    {labels?.bank?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{bank?.description || ''}</b>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    {labels?.code?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{bank?.code || ''}</b>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    {labels?.rif?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{bank?.rif || ''}</b>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    {`${labels?.country?.[languageObj?.id]}`}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{countries?.find(({ id }) => id === bank?.countryId)?.description || ''}</b>
                                </div>
                            </div>
                        </div>
                    }
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning mx-1'
                                    hidden={processType === 2}
                                    tooltip='tooltip'
                                    title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}